<template>
    <vx-card title="Opcije" class="mt-6">
        <div class="vx-row justify-between">
            <div class="vx-col xl:w-5/12 lg:w-5/12 w-full">
                <vs-table noDataText="Ni opcij" ref="table" v-model="selected" @selected="handleSelectedOption" pagination :max-items="50" :data="options">

                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                        <div class="flex flex-wrap-reverse items-center">
                            <vs-button class="mb-3" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addOptionPrompt = true">Dodaj opcijo</vs-button>
                        </div>

                        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ options.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : options.length }} of {{ options.length }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>

                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="itemsPerPage=10">
                                    <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=20">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=50">
                                    <span>50</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="itemsPerPage=100">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <template slot="thead">
                        <vs-th sort-key="name">Ime</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
            </div>

            <div class="vx-col xl:w-6/12 lg:w-6/12 w-full">

                <h3>Urejanje opcije</h3>
                <p class="mt-3" v-if="!optionItems">Opcija ni izbrana</p>
                <div v-if="optionItems">
                    <p class="mt-6">Ime</p>
                    <vx-input-group class="mb-base">

                        <vs-input v-model="editOptionName" tyle="width: 100%"/>
                        <template slot="append">
                            <div class="append-text btn-addon">
                                <vs-button @click="saveOptionName" color="primary">Shrani</vs-button>
                                <vs-button @click="removeOption" color="primary">Izbriši</vs-button>
                            </div>
                        </template>
                    </vx-input-group>

                    <vs-table class="mt-6" noDataText="Ni izbire" ref="table" v-model="selectedItem" @selected="handleSelectedOptionItem" pagination :max-items="50" :data="optionItems">

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                            <div class="flex flex-wrap-reverse items-center">
                                <vs-button class="mb-3" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addOptionItemPrompt = true">Dodaj izbiro</vs-button>
                            </div>
                        </div>

                        <template slot="thead">
                            <vs-th sort-key="item_name">Ime</vs-th>
                            <vs-th sort-key="item_name">Tip spremembe cene</vs-th>
                            <vs-th sort-key="item_name">Sprememba</vs-th>
                            <vs-th sort-key="item_name">Spremeni na koncu</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].item_name">
                                    {{ data[index].item_name }}
                                </vs-td>

                                <vs-td v-if="data[index].price_change_type === 0" :data="data[index].price_change_type">
                                    Brez spremembe
                                </vs-td>

                                <vs-td v-if="data[index].price_change_type === 1" :data="data[index].price_change_type">
                                    Fiksna sprememba
                                </vs-td>

                                <vs-td v-if="data[index].price_change_type === 2" :data="data[index].price_change_type">
                                    Faktor
                                </vs-td>

                                <vs-td :data="data[index].change">
                                    {{ data[index].change }}
                                </vs-td>

                                <vs-td v-if="data[index].change_on_end" :data="data[index].change_on_end">
                                    Da
                                </vs-td>

                                <vs-td v-if="!data[index].change_on_end" :data="data[index].change_on_end">
                                    Ne
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </div>
            </div>

        </div>

        <vs-popup title="Dodaj opcijo" :active.sync="addOptionPrompt">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="addOptionName" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addOption">Dodaj</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Dodaj izbiro" :active.sync="addOptionItemPrompt">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="addOptionItemName" style="width: 100%"></vs-input>
                <p class="mt-6">Tip spremembe cene</p>
                <vs-select class="selectExample" v-model="addOptionItemChangeType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Brez spremembe'}, {id:1, name:'Fiksna sprememba'}, {id:2, name:'Množenje'}]" />
                </vs-select>
                <p v-if="addOptionItemChangeType === 1" class="mt-6">Sprememba cene</p>
                <p v-if="addOptionItemChangeType === 2" class="mt-6">Faktor</p>
                <vs-input v-if="addOptionItemChangeType > 0" v-model="addOptionItemChange" style="width: 100%"></vs-input>
                <vs-checkbox v-if="addOptionItemChangeType===2" class="mt-6" v-model="addOptionItemChangeOnEnd">Spremeni na koncu (všteti bodo dodatki)</vs-checkbox>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addOptionItem">Dodaj</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Uredi" :active.sync="editOptionItemPrompt">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="editOptionItemName" style="width: 100%"></vs-input>
                <p class="mt-6">Tip spremembe cene</p>
                <vs-select class="selectExample" v-model="editOptionItemChangeType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Brez spremembe'}, {id:1, name:'Fiksna sprememba'}, {id:2, name:'Množenje'}]" />
                </vs-select>
                <p v-if="editOptionItemChangeType === 1" class="mt-6">Sprememba cene</p>
                <p v-if="editOptionItemChangeType === 2" class="mt-6">Faktor</p>
                <vs-input v-if="editOptionItemChangeType > 0" v-model="editOptionItemChange" style="width: 100%"></vs-input>
                <vs-checkbox v-if="editOptionItemChangeType===2" class="mt-6" v-model="editOptionItemChangeOnEnd">Spremeni na koncu (všteti bodo dodatki)</vs-checkbox>
                <vs-divider/>
                <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" class="mt-6; mr-1" @click="editOptionItem">Shrani</vs-button>
                <vs-button style="float: right" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeOptionItem">Izbriši</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    export default {
        props: {
            baseURL: {
                type: String,
                required: true
            },
        },
        data(){
            return {

                selected: {},
                selectedItem: {},
                options: [],
                optionItems: null,

                itemsPerPage: 20,
                isMounted: false,

                addOptionPrompt: false,
                addOptionItemPrompt: false,
                editOptionItemPrompt: false,

                addOptionName: '',

                editOptionName: '',

                addOptionItemName: '',
                addOptionItemChangeType: 0,
                addOptionItemChange: 0,
                addOptionItemChangeOnEnd: true,

                editOptionItemName: '',
                editOptionItemChangeType: 0,
                editOptionItemChange: 0,
                editOptionItemChangeOnEnd: true,
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelectedOption(tr) {
                this.editOptionName = tr.name;
                this.optionItems = tr.items;
            },
            handleSelectedOptionItem(tr) {
                this.editOptionItemName = tr.item_name;
                this.editOptionItemChangeType = tr.price_change_type;
                this.editOptionItemChange = tr.change;
                this.editOptionItemChangeOnEnd = tr.change_on_end;
                this.editOptionItemPrompt = true;
            },
            updateOptions() {
                const thisIns = this;
                this.$http.get(this.baseURL + "/option")
                    .then(function (response) {
                        thisIns.options = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            addOption(){
                const thisIns = this;
                this.$http.post(this.baseURL + "/option", {
                    name: this.addOptionName,
                })
                    .then(function () {
                        thisIns.updateOptions();
                        thisIns.addOptionPrompt = false;
                        thisIns.addOptionName = ''
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            addOptionItem(){
                const thisIns = this;

                if(Number(this.addOptionItemChangeType) !== 2) this.addOptionItemChangeOnEnd = false;
                if(Number(this.addOptionItemChangeType) === 0) this.addOptionItemChange = 0;

                this.$http.post(this.baseURL + "/option/" + this.selected.id + "/item", {
                    item_name: this.addOptionItemName,
                    price_change_type: Number(this.addOptionItemChangeType),
                    change: Number(this.addOptionItemChange),
                    change_on_end: this.addOptionItemChangeOnEnd
                })
                    .then(function () {
                        thisIns.updateOptions();
                        thisIns.addOptionItemPrompt = false;
                        thisIns.addOptionItemName = '';
                        thisIns.optionItems = null
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            saveOptionName(){
                const thisIns = this;
                this.$http.put(this.baseURL + "/option/" + this.selected.id, {
                    name: this.editOptionName,
                })
                    .then(function () {
                        thisIns.updateOptions();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            editOptionItem(){
                const thisIns = this;
                if(Number(this.editOptionItemChangeType) !== 2) this.editOptionItemChangeOnEnd = false;
                if(Number(this.editOptionItemChangeType) === 0) this.editOptionItemChange = 0;
                this.$http.put(this.baseURL + "/option/" + this.selected.id + "/item/" + this.selectedItem.id, {
                    item_name: this.editOptionItemName,
                    price_change_type: Number(this.editOptionItemChangeType),
                    change: Number(this.editOptionItemChange),
                    change_on_end: this.editOptionItemChangeOnEnd
                })
                    .then(function () {
                        thisIns.updateOptions();
                        thisIns.optionItems = null
                        thisIns.editOptionItemPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            removeOption(){
                const thisIns = this;
                this.$http.delete(this.baseURL + "/option/" + this.selected.id)
                    .then(function () {
                        thisIns.updateOptions();
                        thisIns.optionItems = null;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            removeOptionItem(){
                const thisIns = this;
                this.$http.delete(this.baseURL + "/option/" + this.selected.id + "/item/" + this.selectedItem.id)
                    .then(function () {
                        thisIns.updateOptions();
                        thisIns.optionItems = null;
                        thisIns.editOptionItemPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        watch: {
            editOptionItemPrompt: function () {
                if(!this.editOptionItemPrompt){
                    this.selectedItem = {}
                }
            },
            baseURL(){
                this.updateOptions();
                this.optionItems = null;
            }
        },
        created() {
            this.updateOptions()
        },
        mounted() {
            this.isMounted = true;
        },
    }

</script>
